module.exports = __webpack_public_path__ + "assets/media/lunch.2563d19b.mp3";